import Charts from "react-apexcharts";
import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../Common/CommonCardHeader";
import { OrderStatusHeading } from "../../../Constant";
import { OPTION_LINE_CHART } from "../../../Data/Widgets/ChartWidgets";

const OrderStatus2 = () => {
  return (
    <Col xl="7" lg="12" className="box-col-6">
      <Card>
        <CommonCardHeader title={OrderStatusHeading} className="border-bottom-1" />
        <CardBody>
          <div className="chart-container" id="chart-widget8">
            <Charts options={OPTION_LINE_CHART} series={OPTION_LINE_CHART.series} height={350} type="line"/>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default OrderStatus2;
